/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslate } from 'hooks/useTranslate';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { setMenuType } from 'modules/_shared/redux/menuActions';
import { resetStateSociety } from 'modules/_shared/redux/resetActions';
import { getUserSocieties } from 'modules/society/redux/societyActions';

import menuTypes from 'constants/menuTypes';

import CardLoader from 'modules/_shared/components/Cards/CardLoader';
import SocietyCard from '../../components/SocietyCard';

import '../ParticipatedList/ParticipatedList.scss';
import societyOptions from './societyOptions';

const AdministratedTable = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state);

  const [cards, setCards] = useState([]);
  const [administratedData, setAdministratedData] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    dispatch(setMenuType(menuTypes.MAIN));
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      getUserSocieties(
        user['_id'],
        'admin',
        setAdministratedData,
        'cards'
      ).then((result) => {
        if (!result?.length) {
          setIsLoadingData(false);
        }
      });
    }
  }, [user]);

  useEffect(() => {
    setCards(
      administratedData.map((data) => (
        <SocietyCard
          data={data}
          userId={user['_id']}
          key={data?.society?.['_id']}
          alternativeMenuOptions={societyOptions}
          isAdmin={data?.isUserAdmin}
          isExternal={!data?.isUserAdmin}
        />
      ))
    );
  }, [administratedData]);

  useEffect(() => {
    dispatch(resetStateSociety());
  }, [cards]);

  return (
    <div className="nk-content-body">
      <div className="nk-content-wrap">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">
                {t('AdministratedTitle')}
              </h3>
              <div className="nk-block-des text-soft">
                <p>
                  {administratedData?.length === 0
                    ? t('AdministratedNoSocieties')
                    : t('AdministratedHaveSocieties', {
                        count: administratedData?.length,
                      })}
                </p>
              </div>
            </div>

            <div className="nk-block-head-content">
              <div className="toggle-wrap nk-block-tools-toggle">
                <div className="toggle-expand-content" data-content="pageMenu">
                  <ul className="nk-block-tools g-3">
                    <li>
                      <Link to="/lista-administradas">
                        <button type="button" className="btn btn-primary">
                          <em className="icon ni ni-view-list-wd" />
                          <span>{t('View')}</span>
                        </button>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cuadro-participadas__main d-flex flex-wrap g-gs">
          {cards?.length > 0 ? (
            cards
          ) : (
            <>
              <div className="w-100 pt-1">
                {isLoadingData && <CardLoader cards={6} />}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdministratedTable;
